const SetColourDirective = function () {
    return function (scope, element, attrs) {
        var options = {
            styleAttr: "color"
        }

        if (attrs.styleAttribute)
            options.styleAttr = attrs.styleAttribute;

        attrs.$observe("setColour", function (val) {
            if (val) {
                setColour(val);
            }
        });

        function setColour(colourString) {
            if (attrs.setColour.length == 9) {
                var result = hexToRGBA(colourString);
                element.css("color", "rgba({0}, {1}, {2}, {3})".format(result.RGB[0], result.RGB[1], result.RGB[2], result.alpha));
            }
            else {
                element.css("color", colourString);
            }
        }

        function hexToRGBA(colourString) {
            // Remove hash
            var hex = colourString.slice(1);

            // Split to four channels
            var channels = hex.match(/.{1,2}/g);

            // Function: to decimals (for RGB)
            var decimal = function (v) {
                return parseInt(v, 16);
            };
            // Function: to percentage (for alpha), to 3 decimals
            var percentage = function (v) {
                // @ts-ignore: TS2345: Argument of type 'number' is not assignable to parameter of type 'string'
                return parseFloat(parseInt((parseInt(v, 16) / 255) * 1000) / 1000);
            };

            var alpha, rgb = [];

            // Convert array into rgba values
            alpha = percentage(channels[3]);
            $.each(channels.slice(0, 3), function (index, val) {
                rgb.push(decimal(val));
            });

            return {
                alpha: alpha,
                RGB: rgb
            };
        }
    }
};

export { SetColourDirective };